import {
  SETTINGS_TABS,
  SettingsTabEnum,
  getSettingsTabIndex
} from './settingsTabs';

type Props = {
  activeTab: SettingsTabEnum;
  onChange: (tab: SettingsTabEnum) => void;
};

const backButtonClassName =
  'inline-flex items-center justify-center rounded border border-grey-300 bg-white px-4 py-2.5 text-sm font-medium text-grey-900 hover:bg-grey-50';

const nextButtonClassName =
  'inline-flex items-center justify-center rounded bg-secondary px-4 py-2.5 text-sm font-semibold text-white hover:bg-secondary-dark';

const SettingsTabNav = ({ activeTab, onChange }: Props) => {
  const activeIndex = getSettingsTabIndex(activeTab);
  const previousTab =
    activeIndex > 0 ? SETTINGS_TABS[activeIndex - 1] : undefined;
  const nextTab =
    activeIndex >= 0 && activeIndex < SETTINGS_TABS.length - 1
      ? SETTINGS_TABS[activeIndex + 1]
      : undefined;

  return (
    <div className="mt-8 flex items-center justify-between gap-4">
      {previousTab ? (
        <button
          type="button"
          className={backButtonClassName}
          onClick={() => onChange(previousTab.value)}>
          &larr; {previousTab.label}
        </button>
      ) : (
        <span />
      )}
      {nextTab ? (
        <button
          type="button"
          className={nextButtonClassName}
          onClick={() => onChange(nextTab.value)}>
          {nextTab.label} &rarr;
        </button>
      ) : (
        <span />
      )}
    </div>
  );
};

export default SettingsTabNav;
